export default __webpack_public_path__ + "static/media/P-046.15fd3bc3.png";